<script lang="ts">
  import BaseModule from '$src/js/modules/base/BaseModule';
</script>

<div class="pt-20 md:pt-45" id="vote">
  <div class="mx-auto flex max-w-[1200px] flex-col items-center px-4">
    <h2
      class="font-clorat text-yellow mb-6 text-center text-[40px] leading-[100%] text-balance sm:mb-8 sm:text-[80px] lg:text-[120px]"
    >
      {BaseModule.getInstance().i18n.translate('vote_done_title')}
    </h2>

    <p
      class="mb-8 max-w-[560px] text-center text-[16px] leading-[180%] font-light sm:mb-16 sm:text-[20px] lg:text-[24px]"
    >
      {BaseModule.getInstance().i18n.translate('vote_done_text')}
    </p>

    <div
      class="xs:flex-row xs:gap-12 mb-16 flex w-full max-w-[600px] flex-col justify-center gap-10"
    >
      <div class="relative flex flex-1 flex-col items-center gap-2">
        <div
          class="jersey-option gradient-border gradient-border--rounded xs:w-full aspect-square w-56 rounded-full"
        >
          <img
            class="h-full w-full rounded-full object-cover"
            src="https://yellow-b-global.b-cdn.net/production/the-architect/images/thumb1.jpg"
            alt=""
          />
        </div>
      </div>

      <div class="relative flex flex-1 flex-col items-center gap-2">
        <div
          class="jersey-option gradient-border gradient-border--rounded xs:w-full aspect-square w-56 rounded-full"
        >
          <img
            class="h-full w-full rounded-full object-cover"
            src="https://yellow-b-global.b-cdn.net/production/the-architect/images/thumb2.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @reference '$src/css/main.css';

  .jersey-option {
    @apply outline-3 outline-offset-4 outline-transparent;
  }
</style>
